import React, { Component } from "react";
import { Overlay, Popover } from "react-bootstrap";
import api from '../../apiClient/v1';
import * as css from "./comentariosIG.css";

class ComentarioIG extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            idInventario: props.idInventario,
            comentarios: [],
            loading: false,
            saving: false
        }
    }

    handleClick(e) {
        this.setState({
            target: e.target,
            show: !this.state.show
        });
    }

    handleClose() {
        this.setState({
            show: false
        });
    }

    getComentarios() {
        this.setState({
            loading: true
        });
        api.comentarios_inv.getComentarios(this.state.idInventario)
            .then(resp => {
                this.setState({
                    comentarios: resp.comentarios,
                    loading: false,
                })
            })
            .catch(err => {
                console.log("Error al cargar comentarios")
                this.setState({
                    loading: false
                });
            })
    }

    saveComentario(comentario) {
        this.setState({
            saving: true
        });
        api.comentarios_inv.saveComentario(this.state.idInventario, {
            comentario: comentario
        }).then(resp => {
            this.setState({
                saving: false,
                comentarios: resp.comentarios
            });
        }).catch(err => {
            console.log("Error al enviar/recibir comentario");
            this.setState({
                saving: false
            });
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.show == true && prevState.show == false) {
            this.setState({
                loading: true
            });
            api.comentarios_inv
                .getComentarios(this.state.idInventario)
                .then(resp => {
                    this.setState({
                        comentarios: resp.comentarios,
                        loading: false
                    });
                })
                .catch(err => {
                    console.log("Error al enviar/recibir comentario");
                    this.setState({
                        loading: false
                    });
                })
        }
    }

    render() {
        return (
            <div style={this.state.show ? { backgroundColor: "#17b485" } : {}}>
                <button onClick={this.handleClick.bind(this)} >
                    <i className="glyphicon glyphicon-comment"></i>
                </button>
                <Overlay
                    show={this.state.show}
                    target={this.state.target}
                    placement={this.props.placement ? this.props.placement : "left"}
                    onHide={this.handleClose.bind(this)}
                    rootClose
                >
                    <Popover
                        id={this.state.idInventario}
                        bsClass={css.comentarios_popover + " popover"}
                    >
                        {!this.state.loading
                            ?
                            <div>
                                {this.state.comentarios.map((registro, index) => {
                                    return (
                                        <div key={this.state.idInventario + "." + index} style={{
                                            paddingLeft: 5,
                                            paddingRight: 5
                                        }} title={registro.created_at}>
                                            <span  style={{
                                                fontSize: 10
                                            }}>{registro.usuario + ": "}</span>
                                            <span style={{
                                                fontSize: 12
                                            }}>{registro.comentario}</span>
                                        </div>
                                    )
                                })}
                                <FormText
                                    save={this.saveComentario.bind(this)}
                                    saving={this.state.saving}
                                />
                            </div>
                            : <div style={{ padding: "20px" }}>Cargando...</div>}
                    </Popover>
                </Overlay>
            </div>
        )
    }
}
export default ComentarioIG;


class FormText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaulttext: "",
            textarea: "",
            visible: false,
            rows: 5,
            enable: true
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCancelar = this.handleCancelar.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.save(this.state.textarea.trim());
    }
    handleChange(e) {
        this.setState({
            textarea: e.target.value,
            visible: true
        });
        const currentRows = e.target.scrollHeight / 17;
        if (currentRows <= 5) {
            this.setState({ rows: currentRows });
        }
    }

    handleCancelar() {
        this.setState((state) => ({
            textarea: state.defaulttext,
            visible: false
        }));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.saving == false && prevProps.saving == true) {
            this.setState({
                defaulttext: "",
                textarea: "",
                visible: false,
                rows: 5,
                enable: true
            });
        }
    }

    render() {
        return (
            <div className={css.formulario} >
                <form onSubmit={this.handleSubmit}>
                    <div className={css.mytextarea}>
                        <textarea
                            disabled={this.props.saving}
                            ref={(text) => this.textArea = text}
                            onChange={this.handleChange}
                            value={this.state.textarea}
                            maxLength={200}
                            rows={this.state.rows}
                            type="text"
                        />
                    </div>
                    {this.state.visible
                        ? <div className="">
                            <button disabled={this.props.saving} type="submit" className="btn btn-success btn-xs"><i className="glyphicon glyphicon-ok"></i></button>
                            <button disabled={this.props.saving} type="button" onClick={this.handleCancelar} className="btn btn-danger btn-xs"><i className="glyphicon glyphicon-remove"></i></button>
                        </div>
                        : null
                    }
                    {this.props.saving && <div>Guardando...</div>}
                </form>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/ComentarioIG.jsx